'use client';

import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import {
  pageVariants,
  pageTransition,
  reducedMotionVariants,
  reducedMotionTransition,
} from '@/lib/animations';

interface PageTransitionProps {
  children: React.ReactNode;
  routeKey: string;
}

export default function PageTransition({ children, routeKey }: PageTransitionProps) {
  const prefersReducedMotion = useReducedMotion();

  const variants = prefersReducedMotion ? reducedMotionVariants : pageVariants;
  const transition = prefersReducedMotion ? reducedMotionTransition : pageTransition;

  return (
    <motion.div
      key={routeKey}
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
      style={{ width: '100%', height: '100%' }}
    >
      {children}
    </motion.div>
  );
}
